import React, { useState } from 'react';
import styled from 'styled-components';
import {
  deleteGhostEmailByIndex,
  getGhostEmails,
  GhostEmail,
} from './ghostEmailList';
import TrueImpactModal, {
  modalHeightAutoStyles,
  modelExtraRadiusStyles,
} from '../../design-system/components/TrueImpactModal';
import TrueImpactText from '../../design-system/base/TrueImpactText';
import TrueImpactIconButton from '../../design-system/components/TrueImpactIconButton';
import { faTrash } from '@fortawesome/pro-light-svg-icons';
import { SPACERS } from '../../design-system/settings/variables/Spacers';
import { COLORS } from '../../design-system/settings/variables/Colors';

interface GhostsModalProps {
  handleClose: () => unknown;
  handleEmailChange: (email: string) => unknown;
}
const styles = `.modal-header { border-bottom: 1px solid ${COLORS.ctaPrimaryBackground}; }`;

const StyledDiv = styled.div`
  .no-emails-found {
    padding: ${SPACERS.small};
  }
  .email-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: background 0.5s;
    .email-text {
      flex: 1;
      cursor: pointer;
      padding: ${SPACERS.small};
      .email-type {
        font-size: 10px;
        padding: 2px ${SPACERS.extraTiny};
        background-color: ${COLORS.brown};
        border-radius: ${SPACERS.extraTiny};
      }
    }
    .email-delete-button {
      transition: background 0.5s;
      margin: ${SPACERS.tiny} ${SPACERS.small} ${SPACERS.tiny} 0;
      &:hover {
        background-color: ${COLORS.grayBase} !important;
      }
    }
  }
  .email-row:hover {
    background-color: ${COLORS.ctaPrimaryBackground};
  }
`;

const GhostsModal: React.FC<GhostsModalProps> = ({
  handleClose,
  handleEmailChange,
}) => {
  const [ghostEmails, setGhostEmails] = useState<GhostEmail[]>(
    getGhostEmails(),
  );

  return (
    <TrueImpactModal
      open={Boolean(open)}
      maxWidth="700px"
      hideFooter={true}
      onClose={handleClose}
      addStyles={modalHeightAutoStyles + modelExtraRadiusStyles + styles}
    >
      <StyledDiv>
        {ghostEmails.length === 0 && (
          <TrueImpactText className="no-emails-found">
            No ghosted emails were found.
          </TrueImpactText>
        )}
        {ghostEmails.map((e, i) => (
          <div key={e.email} className="email-row">
            <TrueImpactText
              className="email-text"
              onClick={() => {
                handleEmailChange(e.email);
                handleClose();
              }}
            >
              {e.email}
              {e.type !== 'admin' && (
                <span className="email-type">{e.type}</span>
              )}
            </TrueImpactText>
            <TrueImpactIconButton
              icon={faTrash}
              backgroundColor="whiteBase"
              className="email-delete-button"
              onClick={() => {
                setGhostEmails(s => {
                  const newState = [...s];
                  newState.splice(i, 1);
                  return newState;
                });
                deleteGhostEmailByIndex(i);
              }}
            />
          </div>
        ))}
      </StyledDiv>
    </TrueImpactModal>
  );
};

export default GhostsModal;
